import { gql } from '@apollo/client'
import { DRAW_MAP_TASK_FRAGMENT } from '../fragments/DrawMapTaskFragment'

export const DELETE_DRAW_MAP_TASK_COMMENT = gql`
  mutation DeleteMapDrawTaskComment($commentId: ID!) {
    deleteMapDrawTaskComment(commentId: $commentId) {
      indoorMapDrawTask {
        ...DrawMapTask
      }
    }
  }
  ${DRAW_MAP_TASK_FRAGMENT}
`
